import { fork, takeEvery } from "redux-saga/effects";
import { filterInputSetNumberRangeFieldValue, filterInputSetSelectFieldValue, preferenceSetCurrency, filterClear } from "../actions";
import { calculateFilterSettings } from "./calculateFilterSettings";
import { clearFilter } from "./clearFilterSettings";
import { filterTable } from "./filterTable";
import { loadingSaga } from "./loading";
import { paramsToQueryStringSerialize } from "./paramsToQueryStringSerialize";

export function* rootSaga() {
	yield fork(loadingSaga);

	yield takeEvery(preferenceSetCurrency, calculateFilterSettings, true);
	yield takeEvery(filterClear, clearFilter);

	yield takeEvery(filterInputSetSelectFieldValue, paramsToQueryStringSerialize);
	yield takeEvery(filterInputSetNumberRangeFieldValue, paramsToQueryStringSerialize);

	yield takeEvery(filterInputSetSelectFieldValue, filterTable);
	yield takeEvery(filterInputSetNumberRangeFieldValue, filterTable);
}